import { CommonComponentsModule } from 'src/app/component/common-components/common-components.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewUserProfileComponent } from './view-user-profile/view-user-profile.component';
import { EditUserProfileComponent } from './edit-user-profile/edit-user-profile.component';
import { UserProfileService } from './service/user-profile.service';
import { ChangePasswordUserProfileComponent } from './change-password-user-profile/change-password-user-profile.component';
import { InputUsernameComponent } from './input-username/input-username.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { RouterModule } from '@angular/router';
import { PartyModule } from '../party/party.module';

const components = [ViewUserProfileComponent, EditUserProfileComponent, ChangePasswordUserProfileComponent, InputUsernameComponent];

@NgModule({
    declarations: [components],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule, RouterModule, PartyModule, CommonComponentsModule],
    exports: [components]
})
export class UserProfileModule {
    static forRoot(): ModuleWithProviders<UserProfileModule> {
        return {
            ngModule: UserProfileModule,
            providers: [UserProfileService]
        };
    }
}
